//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/TaggedObjectCollection.js";
import "../GeometricAnalysis/GeometricAnalysis.AnalysisManager.js";
let d=[[],[[["gfao_object"],"CreateGapFlushnessBuilder",{R_:{gfao_builder:"GeometricAnalysis.GapFlushnessBuilder"}},1,0],[["scao_object"],"CreateSurfaceContinuityAnalysisBuilder",{R_:{scao_builder:"GeometricAnalysis.SurfaceContinuityAnalysisBuilder"}},1,0],[["caao_object"],"CreateCurveCurvatureAnalysisBuilder",{R_:{caao_builder:"GeometricAnalysis.CurveCurvatureAnalysisBuilder"}},1,0],[["hpao_object"],"CreateHighlightLinesAnalysisBuilder",{R_:{builder:"GeometricAnalysis.HighlightLinesAnalysisBuilder"}},1,0],[["msao_object"],"CreateSectionAnalysisBuilder",{R_:{msao_builder:"GeometricAnalysis.SectionAnalysis.SectionAnalysisBuilder"}},1,0],[["csao_object"],"CreateSectionAnalysisExBuilder",{R_:{csao_builder:"GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder"}},1,0],[["ddao_object"],"CreateDeviationGaugeBuilder",{R_:{devgg_builder:"GeometricAnalysis.DeviationGaugeBuilder"}},1,0],[["ccao_object"],"CreateCurveContinuityBuilder",{R_:{ccao_builder:"GeometricAnalysis.CurveContinuityBuilder"}},1,0],[["siao_object"],"CreateSurfaceIntersectionBuilder",{R_:{siao_builder:"GeometricAnalysis.SurfaceIntersectionBuilder"}},1,0],[["dao_object"],"CreateDraftAnalysisBuilder",{R_:{dao_builder:"GeometricAnalysis.DraftAnalysisBuilder"}},1,0],[["lrao"],"CreateLocalRadiusAnalysisBuilder",{R_:{builder:"GeometricAnalysis.LocalRadiusAnalysisBuilder"}},1,0],[["fcao_object"],"CreateFaceCurvatureAnalysisBuilder",{R_:{fcao_builder:"GeometricAnalysis.FaceCurvatureAnalysisBuilder"}},1,0]],[["CurveAnalysisDisplayObject","GeometricAnalysis.CurveAnalysisDisplay",0],["SurfaceAnalysisDisplayObject","GeometricAnalysis.SurfaceAnalysisDisplay",0],["AnalysisObjectsEx","GeometricAnalysis.AnalysisObjectCollectionEx",0]]];
SPLM.GeometricAnalysis.AnalysisObjectCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.GeometricAnalysis.AnalysisObjectCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;